import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { InboxPreviewConversationMessagesResponse } from 'src/services/__generated__/api'

interface UseGetInboxConversationMessagesParams {
  conversationId: string | null
  includeSystem?: boolean
  limit?: number
  offset?: number
}

export const useGetInboxConversationMessagesQuery = ({
  conversationId,
  includeSystem,
  limit = 50,
  offset = 0,
}: UseGetInboxConversationMessagesParams) =>
  useQuery<InboxPreviewConversationMessagesResponse | null>({
    enabled: !!conversationId,
    queryFn: async () => {
      if (!conversationId) return null
      const { data } =
        await AnalyticsApi.v1Private.inboxAnalysisInboxPreviewConversationsMessagesDetail(
          conversationId,
          { includeSystem, limit, offset },
          { format: 'json' }
        )
      return data as InboxPreviewConversationMessagesResponse
    },
    queryKey: [
      QueryKey.GET_INBOX_PREVIEW_CONVERSATION_MESSAGES,
      conversationId,
      limit,
      offset,
      includeSystem ?? false,
    ],
  })
